<i18n src='../../static/localization/analytics.json'></i18n>
<template>
  <div id="analytics">
    <!-- <span class="icon closeicon is-small" v-on:click="showAnalytics=!showAnalytics">
      <i class="fa fa-times-circle" aria-hidden="true"></i>
    </span> -->
    <div v-show="loader" class="spinner">
          <i class="fa fa-circle-o-notch fa-spin fa-3x" style="font-size:40px;color:#228D7A;"></i>
    </div>
    <div v-show="loader" class="spinnerBackground"></div>

  <div class="controlPanel">
    <div class="selectSensor">
      <p class="annot">{{ $t('controlPanel.selectSensor') }}</p>
      <v-select :value.sync="selectedSensor" label="label" :on-change="selectSensor" :options="sensors"></v-select>
    </div>    
    <div class="selectDate">
      <p class="annot">{{ $t('controlPanel.selectDate') }}</p>
      <input class="datepicker" type="text" name="daterange" />
    </div>
  </div>
  <div class="columns is-desktop dashboard">
    <div class="column">
    <div class="statsDashboard">
      <div class="columns">
        <div class="column is-4 stats">
          <div class="headingCard">
            <p class="title">{{ $t('statsDashboard.currentValues') }} <span class="small">({{ $t('statsDashboard.lastUpdate') }} {{dailyValues.time}})</span></p>
          </div>
          <div class="line upper">
            <div class="card">
              <div class="card-content tempVal">
                <p class="title">{{ $t('statsDashboard.temperature') }}</p>
                <p class="subtitle">{{dailyValues.temp}} &deg;C</p>
              </div>
            </div>
            <div class="card">
              <div class="card-content moistVal">
                <p class="title">{{ $t('statsDashboard.moisture') }}</p>
                <p class="subtitle">{{dailyValues.moist}} %</p>
              </div>
            </div>
          </div>
        
          <div class="line">
            <div class="card">
              <div class="card-content pressVal">
                <p class="title">{{ $t('statsDashboard.pressure') }}</p>
                <p class="subtitle">{{dailyValues.press}} hPa</p>
              </div>
            </div>
            <div class="card">
              <div class="card-content precVal">
                <p class="title">{{ $t('statsDashboard.precipitation') }}</p>
                <p class="subtitle">{{dailyValues.prec}} mm</p>
              </div>
            </div>
          </div>

					<div class="line">
						<div class="card">
              <div class="card-content pressVal">
                <p class="title">{{ $t('statsDashboard.sirr') }}</p>
                <p class="subtitle">{{dailyValues.sirr}} W/m2</p>
              </div>
            </div>

            <div class="card">
              <div class="card-content tempVal">
                <p class="title">{{ $t('statsDashboard.battery') }}</p>
                <p class="subtitle">{{dailyValues.battery}} V</p>
              </div>
            </div>
          </div>


        </div>
      </div>
      
    
      <div class="columns">
        <div class="column is-4 stats">
          <div class="headingCard">
            <p class="title">{{ $t('statsDashboard.dailyStatistics') }}</p>
          </div>
          <div class="line upper dailyStatsTemp">
            <div class="card">
              <div class="card-content">
                <p class="title">{{ $t('statsDashboard.maxTemperature') }}</p>
                <p class="subtitle">{{dailyStats.maxTemp}} &deg;C</p>
              </div>
            </div>
            <div class="card">
              <div class="card-content">
                <p class="title">{{ $t('statsDashboard.minTemperature') }}</p>
                <p class="subtitle">{{dailyStats.minTemp}} &deg;C</p>
              </div>
            </div>
          </div>
          <div class="line dailyStatsMoist">
            <div class="card">
              <div class="card-content">
                <p class="title">{{ $t('statsDashboard.maxRH') }}</p>
                <p class="subtitle">{{dailyStats.maxMoist}} %</p>
              </div>
            </div>
            <div class="card">
              <div class="card-content">
                <p class="title">{{ $t('statsDashboard.minRH') }}</p>
                <p class="subtitle">{{dailyStats.minMoist}} %</p>
              </div>
            </div>
          </div>
        </div>
      </div>
			<div class="totalPrec">
        <div class="card-content">
          <p class="title">{{ $t('statsDashboard.precipitationInterval') }}:  {{totalPrecipitation}} mm</p>
        </div>
      </div>
    </div>
    </div>
	
	

  
  
  </div>

    <div class="chartArea">
			<i class="fa fa-download" v-on:click="downloadData(sensorData)"></i>
      <div id="chartdiv" style="width: 100%; height: 400px;"></div>
      
    </div>
  </div>
</template>

<script>
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'

import vSelect from 'vue-select'
import moment from 'moment'
import $ from 'jquery'
import XLSX from 'xlsx'
import daterangepicker from 'bulma-daterangepicker'

import { HTTP } from '../common/http'
import { store } from '../store/index'
import { componentStrings } from '../../static/localization/componentStrings'

export default {
	name: 'analytics',
	components: {
		vSelect,
	},
	mounted() {
		console.log(JSON.parse(localStorage.getItem('profile')).name)
		if (JSON.parse(localStorage.getItem('profile')).name === 'vupt') $('.dashboard').hide()
		this.$i18n.locale = JSON.parse(localStorage.getItem('profile')).lang
		this.mountDatePicker() // this funtion mounts datepicker
		this.datePickerListener(this) // this function is listening the datepicker events
		this.getSensorList() // gets sensor list to dropdown
	},
	data() {
		return {
			showAnalytics: true,
			sensors: [],
			todayData: [],
			selectedSensor: null,
			sensorToFetch: null,
			selectedDate: null,
			dailyValues: {},
			dailyStats: {},
			loader: false,
			totalPrecipitation: 0,
			sensorData: []
		}
	},
	methods: {
		selectSensor: function(sensor) {
			let inputVal = $('.datepicker').val()
			this.sensorToFetch = sensor.value
			this.dataToChart(
				sensor.value,
				moment.utc(moment(inputVal.split(' - ')[0], 'DD-MM-YYYY')).valueOf(),
				moment.utc(moment(inputVal.split(' - ')[1], 'DD-MM-YYYY')).valueOf()
			)
		},
		getDailyStats: function(sensorId) {
			HTTP.get('/sensors/' + sensorId + '/stats', {
				headers: {
					token: localStorage.getItem('token'),
					user: JSON.parse(localStorage.getItem('credentials')).email,
				},
			})
				.then(response => {
					this.dailyValues = response.data.processedData[0]
					this.dailyStats = response.data.dailyStats
				})
				.catch(error => {
					console.log('ERROR: ' + error)
				})
		},
		dataToChart: function(sensorId, from, to) {
			this.loader = true
			HTTP.get('/sensors/' + sensorId, {
				params: {
					from: from,
					to: to,
					clientType: JSON.parse(localStorage.getItem('profile')).clientType,
				},
				headers: {
					token: localStorage.getItem('token'),
					user: JSON.parse(localStorage.getItem('credentials')).email,
				},
			})
				.then(response => {
					this.sensorData = response.data.processedData
					this.totalPrecipitation = Math.round(response.data.totalPrecipitationForPeriod)
					this.loader = false
					this.getDailyStats(sensorId)
					if (JSON.parse(localStorage.getItem('profile')).name == 'vupt') {
						this.drawChartSOIL(response.data)
					} else {
						this.drawChart(response.data)
					}
					
				})
				.catch(error => {
					console.log('ERROR: ' + error)
				})
		},
		getSensorList: function() {
			HTTP.get('/sensors/byUser/' + JSON.parse(localStorage.getItem('credentials')).email, {
				headers: {
					token: localStorage.getItem('token'),
					user: JSON.parse(localStorage.getItem('credentials')).email,
				},
			})
				.then(response => {
					this.sensors = response.data.data.map(function(sensor) {
						return { label: sensor.label, value: sensor.name }
					})
					this.selectedSensor = this.sensors[0]
				})
				.catch(error => {
					console.log('ERROR: ' + error)
				})
		},
		mountDatePicker: function() {
			$('input[name="daterange"]').daterangepicker({
				// minDate: '25/10/2017',
				startDate: moment(),
				alwaysShowCalendars: true,
				locale: {
					format: 'DD/MM/YYYY',
				},
				ranges: {
					Dnes: [moment(), moment()],
					Vcera: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
					'Last 7 Days': [moment().subtract(6, 'days'), moment()],
					'Last 30 Days': [moment().subtract(29, 'days'), moment()],
					'This Month': [moment().startOf('month'), moment().endOf('month')],
					'Last Month': [
						moment()
							.subtract(1, 'month')
							.startOf('month'),
						moment()
							.subtract(1, 'month')
							.endOf('month'),
					],
				},
			})
			$('.ranges ul li')
				.eq(0)
				.text(componentStrings.datepicker[this.$i18n.locale].today)
			$('.ranges ul li')
				.eq(1)
				.text(componentStrings.datepicker[this.$i18n.locale].yesterday)
			$('.ranges ul li')
				.eq(2)
				.text(componentStrings.datepicker[this.$i18n.locale].last7days)
			$('.ranges ul li')
				.eq(3)
				.text(componentStrings.datepicker[this.$i18n.locale].last30days)
			$('.ranges ul li')
				.eq(4)
				.text(componentStrings.datepicker[this.$i18n.locale].thisMonth)
			$('.ranges ul li')
				.eq(5)
				.text(componentStrings.datepicker[this.$i18n.locale].lastMonth)
			$('.ranges ul li')
				.eq(6)
				.text(componentStrings.datepicker[this.$i18n.locale].customRange)
			$('.applyBtn').text(componentStrings.datepicker[this.$i18n.locale].apply)
			$('.cancelBtn').text(componentStrings.datepicker[this.$i18n.locale].cancel)
		},
		datePickerListener: function(VueInstance) {
			$('.datepicker').on('apply.daterangepicker', function(ev, picker) {
				VueInstance.dataToChart(
					VueInstance.sensorToFetch,
					moment.utc(picker.startDate.format('YYYY-MM-DD')).valueOf(),
					moment.utc(picker.endDate.format('YYYY-MM-DD')).valueOf()
				)
			})
		},
		renameKeys: function(obj, newKeys) {
			const keyValues = Object.keys(obj).map(key => {
				const newKey = newKeys[key] || key;
				return { [newKey]: obj[key] };
			})
			return Object.assign({}, ...keyValues)
		},
		downloadData: function(data) {
			let stats = []
			let uniqueDates = []
			data.forEach(a => {
				if (!uniqueDates.includes(a.time.split(' ')[0])) {
					uniqueDates.push(a.time.split(' ')[0])
				}
			})
			uniqueDates.forEach(b => {
				let temps = []
				let precs = []
				for(let i=0;i<=data.length;i++) {
					if(data[i] && b==data[i].time.split(' ')[0]) {
						temps.push(Number(data[i].temp))
						precs.push(Number(data[i].prec))
					}
				}
				stats.push({
					time: b,
					temp: (temps.reduce( ( p, c ) => p + c, 0 ) / temps.length).toFixed(1),
					prec: (precs.reduce( ( p, c ) => p + c, 0 )).toFixed(1)
				})
			})

			const newObj = []
			data.forEach(val => {
				newObj.push(
				this.renameKeys(val, {
					moist: componentStrings.sensorChart[this.$i18n.locale].moisture,
					prec: componentStrings.sensorChart[this.$i18n.locale].precipitation,
					press: componentStrings.sensorChart[this.$i18n.locale].pressure,
					sirr: componentStrings.sensorChart[this.$i18n.locale].irradiation,
					temp: componentStrings.sensorChart[this.$i18n.locale].temperature,
					time: componentStrings.sensorChart[this.$i18n.locale].time,
					battery: componentStrings.sensorChart[this.$i18n.locale].battery
				}))
			})
			const xlsxSheet = XLSX.utils.json_to_sheet(newObj)
			stats.forEach(x => {
				delete Object.assign(x, {[componentStrings.export[this.$i18n.locale].date]: x['time'] })['time'];
				delete Object.assign(x, {[componentStrings.export[this.$i18n.locale].avgTemp]: x['temp'] })['temp'];
				delete Object.assign(x, {[componentStrings.export[this.$i18n.locale].sumPrec]: x['prec'] })['prec'];
			})
			
			const xlsxSheetStats = XLSX.utils.json_to_sheet(stats)
			const wb = XLSX.utils.book_new()
			const ws = wb.Sheets[wb.SheetNames[0]];
			XLSX.utils.book_append_sheet(wb, xlsxSheet,'Data')
			XLSX.utils.book_append_sheet(wb, xlsxSheetStats,componentStrings.datepicker[this.$i18n.locale].statistics)
			XLSX.writeFile(wb, `export_${moment().format("DDMMYYYY_HH_mm")}.xls`)
		},
		drawChart: function(data) {
			let chart = window.AmCharts.makeChart('chartdiv', {
				type: 'serial',
				theme: 'light',
				pathToImages: '../../static/img/amcharts/images/',
				legend: {
					useGraphSettings: true,
				},
				dataProvider: data.processedData,
				synchronizeGrid: true,
				zoomOutText: componentStrings.datepicker[this.$i18n.locale].showAll,
				valueAxes: [
					{
						id: 'temp',
						axisColor: '#d64444',
						axisAlpha: 1,
						gridAlpha: 0.2,
						axisThickness: 2,
						dashLength: 1,
						position: 'left',
					},
					{
						id: 'moist',
						axisColor: '#89d9f4',
						axisAlpha: 1,
						gridAlpha: 0,
						offset: 50,
						axisThickness: 2,
						dashLength: 1,
						position: 'left',
						min: 0,
						max: 100,
						strictMinMax: true,
						unit: '%',
					},
					{
						id: 'press',
						axisColor: '#ffa100',
						axisAlpha: 1,
						gridAlpha: 0,
						offset: 50,
						axisThickness: 2,
						dashLength: 1,
						minimum: 0,
						position: 'right',
					},
					{
						id: 'prec',
						axisColor: '#003fff',
						axisAlpha: 1,
						gridAlpha: 0,
						minimum: 0,
						axisThickness: 2,
						dashLength: 1,
						position: 'right',
					},
					{
						id: 'sirr',
						axisColor: '#f9d400',
						axisAlpha: 1,
						gridAlpha: 0,
						minimum: 0,
						axisThickness: 2,
						offset: 100,
						dashLength: 1,
						position: 'left',
					},
				],
				mouseWheelZoomEnabled: true,
				graphs: [
					{
						valueAxis: 'temp',
						id: 'temp',
						// type: 'smoothedLine',
						balloonText: '[[value]] &deg;C',
						lineColor: '#d64444',
						title: componentStrings.sensorChart[this.$i18n.locale].temperature,
						valueField: 'temp',
						fillAlphas: 0,
						useLineColorForBulletBorder: true,
					},
					{
						valueAxis: 'moist',
						id: 'moist',
						// type: 'smoothedLine',
						balloonText: '[[value]] %',
						lineColor: '#89d9f4',
						title: componentStrings.sensorChart[this.$i18n.locale].moisture,
						valueField: 'moist',
						fillAlphas: 0,
						useLineColorForBulletBorder: true,
					},
					{
						valueAxis: 'press',
						id: 'press',
						// type: 'smoothedLine',
						balloonText: '[[value]] hPa',
						lineColor: '#ffa100',
						title: componentStrings.sensorChart[this.$i18n.locale].pressure,
						valueField: 'press',
						fillAlphas: 0,
						useLineColorForBulletBorder: true,
					},
					{
						valueAxis: 'prec',
						id: 'prec',
						type: 'column',
						balloonText: '[[value]] mm',
						lineColor: '#003fff',
						title: componentStrings.sensorChart[this.$i18n.locale].precipitation,
						valueField: 'prec',
						fillAlphas: 0,
						useLineColorForBulletBorder: true,
					},
					{
						valueAxis: 'sirr',
						id: 'sirr',
						// type: 'smoothedLine',
						balloonText: '[[value]] Watt/m2',
						lineColor: '#f9d400',
						title: componentStrings.sensorChart[this.$i18n.locale].irradiation,
						valueField: 'sirr',
						fillAlphas: 0,
						useLineColorForBulletBorder: true,
					},
				],
				chartScrollbar: {
					autoGridCount: true,
					graph: 'temp',
					scrollbarHeight: 60,
					dragIcon: 'dragIconRectSmall',
					dragIconWidth: 20,
					dragIconHeight: 25,
				},
				chartCursor: {
					// "limitToGraph":"temp",
					// "cursorPosition": "mouse"
				},
				dataDateFormat: 'DD/MM/YYYY JJ:NN',
				categoryField: 'time',
				categoryAxis: {
					parseDates: true,
					axisColor: '#DADADA',
					dashLength: 1,
					minorGridEnabled: true,
					labelFrequency: 2,
					minPeriod: 'mm',
					columnWidth: 0.5,
				}
			})

			chart.addListener('rendered', zoomChart)
			zoomChart()

			// this method is called when chart is first inited as we listen for "rendered" event
			function zoomChart() {
				// different zoom methods can be used - zoomToIndexes, zoomToDates, zoomToCategoryValues
				chart.zoomToIndexes(data.processedData.length - 40, data.processedData.length - 1)
			}
		},
		drawChartSOIL: function(data) {
			console.log(data)
					let chart = window.AmCharts.makeChart('chartdiv', {
						type: 'serial',
						theme: 'light',
						pathToImages: '../../static/img/amcharts/images/',
						legend: {
							useGraphSettings: true,
						},
						dataProvider: data.processedData,
						synchronizeGrid: true,
						zoomOutText: componentStrings.datepicker[this.$i18n.locale].showAll,
						valueAxes: [
							{
								id: 'temp1',
								axisColor: '#d64444',
								axisAlpha: 1,
								gridAlpha: 0.2,
								axisThickness: 2,
								dashLength: 1,
								position: 'left',
								offset: 50
							},
							{
								id: 'msb1',
								axisColor: '#89d9f4',
								axisAlpha: 1,
								gridAlpha: 0,
								offset: 50,
								axisThickness: 2,
								dashLength: 1,
								position: 'right',
								min: 0,
								max: 100,
								strictMinMax: true,
								unit: '%',
							}
						],
						mouseWheelZoomEnabled: true,
						graphs: [
							{
								valueAxis: 'temp1',
								id: 'temp1',
								// type: 'smoothedLine',
								balloonText: '[[value]] &deg;C',
								lineColor: '#ff0000',
								title: 'Teplota 1',
								valueField: 'temp1',
								fillAlphas: 0,
								useLineColorForBulletBorder: true,
							},
							{
								valueAxis: 'temp2',
								id: 'temp2',
								// type: 'smoothedLine',
								balloonText: '[[value]] &deg;C',
								lineColor: '#ff8000',
								title: 'Teplota 2',
								valueField: 'temp2',
								fillAlphas: 0,
								useLineColorForBulletBorder: true,
							},
							{
								valueAxis: 'temp3',
								id: 'temp3',
								// type: 'smoothedLine',
								balloonText: '[[value]] &deg;C',
								lineColor: '#eeff00',
								title: 'Teplota 3',
								valueField: 'temp3',
								fillAlphas: 0,
								useLineColorForBulletBorder: true,
							},
							{
								valueAxis: 'msb1',
								id: 'msb1',
								// type: 'smoothedLine',
								balloonText: '[[value]] kPa',
								lineColor: '#00fff7',
								title: 'Vlhkost 1',
								valueField: 'msb1',
								fillAlphas: 0,
								useLineColorForBulletBorder: true,
							},
							{
								valueAxis: 'msb2',
								id: 'msb2',
								// type: 'smoothedLine',
								balloonText: '[[value]] kPa',
								lineColor: '#004cff',
								title: 'Vlhkost 2',
								valueField: 'msb2',
								fillAlphas: 0,
								useLineColorForBulletBorder: true,
							},
							{
								valueAxis: 'msb3',
								id: 'msb3',
								// type: 'smoothedLine',
								balloonText: '[[value]] kPa',
								lineColor: '#9500ff',
								title: 'Vlhkost 3',
								valueField: 'msb3',
								fillAlphas: 0,
								useLineColorForBulletBorder: true,
							}
						],
						chartScrollbar: {
							autoGridCount: true,
							graph: 't1',
							scrollbarHeight: 60,
							dragIcon: 'dragIconRectSmall',
							dragIconWidth: 20,
							dragIconHeight: 25,
						},
						chartCursor: {
							// "limitToGraph":"temp",
							// "cursorPosition": "mouse"
						},
						dataDateFormat: 'DD/MM/YYYY JJ:NN',
						categoryField: 'time',
						categoryAxis: {
							parseDates: true,
							axisColor: '#DADADA',
							dashLength: 1,
							minorGridEnabled: true,
							labelFrequency: 2,
							minPeriod: 'mm',
							columnWidth: 0.5,
						},
					})

					chart.addListener('rendered', zoomChart)
					zoomChart()

					// this method is called when chart is first inited as we listen for "rendered" event
					function zoomChart() {
						// different zoom methods can be used - zoomToIndexes, zoomToDates, zoomToCategoryValues
						chart.zoomToIndexes(data.processedData.length - 40, data.processedData.length - 1)
					}
				}
	},
}
</script>

<style scoped>
@import '~bulma-daterangepicker/daterangepicker.css';

#analytics {
	position: absolute;
	height: calc(100% - 3.25rem);
	z-index: 1001;
	background: #ffffff;
	margin: 0 auto;
	left: 4rem;
	right: 0;
	bottom: 0;
	display: none;
	overflow-y: auto;
	-webkit-animation: bar 1s ease;
}
@keyframes bar {
	0% {
		bottom: -100%;
	}
	100% {
		bottom: 0%;
	}
}

.chartArea {
	position: relative;
	/* bottom: 30px; */
	width: 100%;
	margin: 0 auto;
}
@media (max-width: 1555px) {
	.chartArea {
		position: relative;
	}
}
.panel {
	display: block;
	position: absolute;
	width: 225px;
}
.panel-heading {
	border-radius: 0;
}
a.panel-block:hover,
label.panel-block:hover {
	background-color: rgba(123, 193, 106, 0.17);
}
.dropdown {
	display: block;
	width: 240px;
	margin-bottom: 25px;
	margin: 0 auto;
	position: relative;
}
.selectDate .datepicker {
	width: 240px;
	height: 36px;
	float: right;
	font-size: 15px;
}
.selectSensor {
	margin-right: 20px;
	margin: 0 auto;
}
.selectDate {
	margin-left: 20px;
	margin: 0 auto;
}
.controlPanel {
	position: relative;
	margin: 0 auto;
	display: flex;
	width: 600px;
	margin-top: 8px;
	margin-bottom: 38px;
}
.dashboard {
	margin-left: 25px;
	margin-right: 25px;
}
.column {
	padding: 0;
}
.daterangepicker.dropdown-menu {
	z-index: 9999 !important;
}
.annot {
	font-size: 16px;
}
.stats {
	display: inline-block;
	min-width: 550px;
	margin: 0 auto;
	margin-bottom: 25px;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}
.widget {
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
	display: inline-block;
	margin-right: 25px;
	/* width: 15%; */
}
.widgetHeader {
	display: table;
	width: 100%;
	box-sizing: border-box;
	padding: 10px 15px;
}
.widgetHeaderTitle {
	width: auto;
	text-align: left;
	padding-right: 15px;
	font-size: 16px;
	color: #333232;
}
.widgetHeaderSubTitle {
	width: auto;
	text-align: left;
	padding-right: 5px;
	font-size: 16px;
	color: #333232;
	font-weight: 600;
}
.widgetBody {
	display: block;
	box-sizing: border-box;
	padding: 0px 15px 10px;
}
.widgetBodyCell {
	display: inline-block;
	vertical-align: top;
	width: 50%;
	box-sizing: border-box;
}
.widgetBodyText {
	position: relative;
	z-index: 1;
	color: #000000;
	font-size: 25px;
}
.widgetBodyInfo {
	position: relative;
	z-index: 1;
	color: #000000;
	font-size: 15px;
}
.statsDashboard {
	padding-left: 25px;
	padding-right: 25px;
}
.widgetDashboard {
	margin-left: 50px;
	width: 30rem;
	margin: 0 auto;
}
.card {
	position: relative;
	display: inline-block;
	max-width: none;
	-webkit-box-shadow: none;
	box-shadow: none;
	border-top: 1px solid #e2e2e2;
}
.stats > .line > .card:first-child {
	border-right: 1px solid #e2e2e2;
}
.stats > .upper > .card:first-child {
	border-top: transparent;
}
.stats > .upper > .card:nth-child(2) {
	border-top: transparent;
}
.card-content {
	padding: 10px;
}

.title {
	font-size: 16px;
	font-weight: 400;
}
.subtitle {
	float: right;
}
.title:not(.is-spaced) + .subtitle {
	margin-top: -1.1rem;
}
.small {
	font-weight: 200;
	font-size: 16px;
}
.headingCard {
	padding: 14px 16px 10px;
	background: #228d7a;
}
.headingCard p {
	color: #ffffff;
	font-weight: 400;
	font-size: 16px;
}
.line {
	width: 100%;
}
.line > .card:first-child {
	float: left;
	width: 50%;
}
.line > .card:nth-child(2) {
	float: right;
	width: 50%;
}
.totalPrec {
	text-align: center;
}
.title:not(:last-child),
.subtitle:not(:last-child) {
	margin-bottom: 0px;
}
.tempVal > .subtitle {
	color: #d64444;
	font-size: 16px;
}
.pressVal > .subtitle {
	color: #ffa100;
	font-size: 16px;
}
.moistVal > .subtitle {
	color: #8cc2f7;
	font-size: 16px;
}
.precVal > .subtitle {
	color: #003fff;
	font-size: 16px;
}
.dailyStatsTemp p {
	color: #ffffff;
	font-size: 16px;
}
.dailyStatsMoist p {
	color: #ffffff;
	font-size: 16px;
}
.dailyStatsPrec p {
	color: #ffffff;
	font-size: 16px;
}
.dailyStatsTemp > .card > .card-content {
	background: #d64444;
}
.dailyStatsMoist > .card > .card-content {
	background: #8cc2f7;
}
.dailyStatsPrec > .card > .card-content {
	background: #003fff;
}
.spinner {
	position: absolute;
	z-index: 999;
	top: 40%;
	left: 50%;
}
.spinnerBackground {
	background: rgba(255, 255, 255, 0.8);
	z-index: 998;
	position: absolute;
	height: 100%;
	width: 100%;
	margin: 0 auto;
	right: 0;
	bottom: 0;
}
@media screen and (max-width: 768px) {
	.columns {
		display: block !important;
	}
	.column {
		display: flex !important;
	}
}
.fa-download {
	position: relative;
	font-size: 22px;
	float: right;
	left: -122px;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// Analytics.vue?81b957ce